import React from 'react'
import { Col, Container, Modal, ModalBody, Row } from 'reactstrap'
import Smallbutton from '../button/Smallbutton'
import img from "../../assets/kangaroo/formclosepink.png"

const FormClosepink = ({ modal, toggle, closeBtn, description, heading, closebtncolor="#fff"}) => {
  return (
   <Modal
      isOpen={modal}
      toggle={toggle}
      centered={true}
      size='lg'
      
    >
      <div style={{
        backgroundImage: `url(${img})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        borderRadius: "4px",
        padding: "20px",
        width: "100%",
        height: "100%"
      }}>
        <ModalBody>
          <Container
            fluid
            className="d-flex flex-column justify-content-center m-0"
            style={{ height: "60vh", width: "100%" }}
          >
            <div>
              <Row className="text-left mb-3 ms-4 " style={{height:"90%"}}>
                <Col >
                  <div>
                    <h1 className="thankyou-font-pink">Thank You</h1>
                    <p className="thankyou-trail-pink mt-5 w-75">{description}</p>
                  </div>
                </Col>
              </Row>

              <Row className="ms-4 ">
                <Col className="d-flex justify-content-start">
                  <div onClick={toggle}>
                    <Smallbutton fill={closebtncolor} text="CLOSE" width="200" strokeWidth={0}/>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </ModalBody>
      </div>
    </Modal>
  )
}

export default FormClosepink